import { TextSelection, NodeSelection, } from 'prosemirror-state';
/**
 * NodeSelection 状态下，在该 Node 后创建空段落
 */
export const createParagraphAfterSelectedBlock = (state, dispatch) => {
    const { selection } = state;
    if (!(selection instanceof NodeSelection)) {
        return false;
    }
    const { to, $to } = selection;
    if (!$to.node().isBlock) {
        return false;
    }
    const { tr, schema } = state;
    tr.insert(to, schema.nodes.paragraph.create());
    tr.setSelection(TextSelection.create(tr.doc, to + 1));
    dispatch === null || dispatch === void 0 ? void 0 : dispatch(tr);
    return true;
};
/**
 * NodeSelection 状态下，在该 Node 前创建空段落
 */
export const createParagraphBeforeSelectedBlock = (state, dispatch) => {
    const { selection } = state;
    if (!(selection instanceof NodeSelection)) {
        return false;
    }
    const { from, $from } = selection;
    if (!$from.node().isBlock) {
        return false;
    }
    const { tr, schema } = state;
    tr.insert(from, schema.nodes.paragraph.create());
    tr.setSelection(TextSelection.create(tr.doc, from + 1));
    dispatch === null || dispatch === void 0 ? void 0 : dispatch(tr);
    return true;
};
//# sourceMappingURL=createParagraphAroundSelectedBlock.js.map